(function(angular){
	'use strict';
	
	angular
		.module('opportunityFundModule')
		.controller('OpportunityFundSignupModalController', [
			'$timeout',
			'APP_BASE_PATH',
			'close',
			'ignoreClose',
			OpportunityFundSignupModalFunction
		]);
	
	function OpportunityFundSignupModalFunction(
		$timeout,
		APP_BASE_PATH,
		close,
		ignoreClose
	){
		var opportunityFundSignupModal = this;
		opportunityFundSignupModal.close = close;
		opportunityFundSignupModal.ignoreClose = ignoreClose;
		opportunityFundSignupModal.currentQuizStep = 1;
		opportunityFundSignupModal.quizTotal = 4;
		opportunityFundSignupModal.capGainsUrl = APP_BASE_PATH + '/education/blog-posts/how-to-roll-over-a-capital-gain-into-an-opportunity-fund';
		opportunityFundSignupModal.accreditedInvestorUrl = APP_BASE_PATH + '/education/glossary/accredited-investor';

		opportunityFundSignupModal.next = function() {
			opportunityFundSignupModal.currentQuizStep += 1;

			$timeout(function() {
				opportunityFundSignupModal.formSubmitted = false;
			});
		};

		opportunityFundSignupModal.back = function() {
			opportunityFundSignupModal.currentQuizStep -= 1;
		};

		opportunityFundSignupModal.close = function() {
			close();
		};

		opportunityFundSignupModal.unlock = function() {
			opportunityFundSignupModal.form.entityType = opportunityFundSignupModal.form.entityType === 'entity' ? 'ENTITY' : 'INDIVIDUAL';
			if (opportunityFundSignupModal.form.hasCapGain === 'CLIENT') {
				opportunityFundSignupModal.form.entityType = 'INVESTMENT_ADVISOR';
			}
			close({
				success: true,
				fields: opportunityFundSignupModal.form
			});
		};
	}
})(window.angular);